export const InputItem = {
    name: {
        id: 'companyName',
        label: 'Tên công ty / cá nhân',
        inputType: 'text'
    },
    phone: {
        id: 'phone',
        label: 'Số điện thoại',
        inputType: 'tel'
    },
    email: {
        id: 'email',
        label: 'Email',
        inputType: 'email'
    },
    taxCode: {
        id: 'taxCode',
        label: 'Mã số thuế',
        inputType: 'text'
    },
    address: {
        id: 'address',
        label: 'Địa chỉ nhận',
        inputType: 'text'
    },
    nationwide: {
        id: 'nationwide',
        label: 'Yêu cầu xuất cho đơn liên tỉnh',
        inputType: 'checkbox',
        icon: 'nationwide'
    },
    splitInvoice: {
        id: 'splitInvoice',
        label: 'Tách hóa đơn khi giá trị hóa đơn vượt quá đ20,000,000',
        inputType: 'checkbox',
        icon: 'split-invoice'
    }
}

export const ahamoveIdInput = {
    id: 'parentId',
    label: 'Chọn AhaMove ID',
    inputType: 'text',
}

export const InvoiceInputList = [
    InputItem.name,
    InputItem.phone,
    InputItem.email,
    InputItem.taxCode,
    InputItem.address
]

export const InvoiceAdditionalInputList = [
    InputItem.nationwide,
    InputItem.splitInvoice
]


export const InformationLeft = [
    InputItem
]
